import { helper } from '@ember/component/helper';

const eq = function (params: [unknown, unknown]) {
	return params[0] === params[1];
};

const eqHelper = helper(eq);

export default eqHelper;
